import useSettings from 'hooks/useSettings';
import { EnumFields } from 'types/enumerationData';

const useGetStateLabel = () => {
    const [setting, loading] = useSettings();
    const stateList = setting[EnumFields.STATE] || [];

    const getStateLabel = (stateCode: string) => {
        // 如果还在加载中，返回原缩写
        if (loading || !stateList.length) {
            return stateCode;
        }
        const state = stateList.find((item) => item.value === stateCode);
        return state?.label || stateCode;
    };
    return { getStateLabel, loading };
};

export default useGetStateLabel;
